import Nozich from './Nozich';

export default {
  Nozich,
};